import API from '@/apiRequest';

const DEFAULT_ERROR_MESSAGE = {
  id: 'orderDetails.bry.configureEnvelopeError',
  defaultMessage: 'Não foi possível abrir a configuração do envelope.',
};

const DEFAULT_ERROR_TITLE = {
  id: 'toast.error.title',
  defaultMessage: 'Erro!',
};

const noop = () => {};

const formatMessage = (intl, descriptor) => {
  if (!intl || typeof intl.formatMessage !== 'function') {
    return descriptor.defaultMessage;
  }

  return intl.formatMessage(descriptor);
};

const showToast =
  (dispatchToast = noop, { intl }) =>
  message => {
    dispatchToast({
      type: 'error',
      title: formatMessage(intl, DEFAULT_ERROR_TITLE),
      text: message,
      duration: 5000,
    });
  };

const createErrorHandler = ({ dispatchToast, intl, onError = noop }) => {
  const emitToast = typeof dispatchToast === 'function' ? showToast(dispatchToast, { intl }) : null;

  return message => {
    if (emitToast) {
      emitToast(message);
    }

    onError(message);
  };
};

export const getBryEnvelopeConfig = async ({ orderId, intl, dispatchToast, onError } = {}) => {
  if (!orderId) return { success: false };

  try {
    const { data } = await API.get(`/orders/${orderId}/resources/config`);
    const href = data.resource?.data?.href;

    if (!href) {
      throw new Error('Missing Bry config href');
    }

    return { success: true, url: href };
  } catch (error) {
    console.error('[openBryEnvelopeConfig] failed to open Bry config', error);

    const message = formatMessage(intl, DEFAULT_ERROR_MESSAGE);
    const handleError = createErrorHandler({ dispatchToast, intl, onError });
    handleError(message);

    return { success: false };
  }
};

export default async function openBryEnvelopeConfig({ orderId, intl, dispatchToast, onError } = {}) {
  if (!orderId) return false;

  try {
    const { data } = await API.get(`/orders/${orderId}/resources/config`);
    const href = data.resource?.data?.href;

    if (!href) {
      throw new Error('Missing Bry config href');
    }

    window.open(href, '_blank', 'noopener,noreferrer');

    return true;
  } catch (error) {
    console.error('[openBryEnvelopeConfig] failed to open Bry config', error);

    const message = formatMessage(intl, DEFAULT_ERROR_MESSAGE);
    const handleError = createErrorHandler({ dispatchToast, intl, onError });
    handleError(message);

    return false;
  }
};
